export const rework_online_monitoring_track_stop = {
  namespaced: true,
  state() { return {
    viewTrackOnMap: null,
    stateTrackStopOnMap: {
      active: false,
    },
  }},
  getters: {
    getViewTrackOnMap: state => state.viewTrackOnMap,
    getStateTrackStopOnMap: state => state.stateTrackStopOnMap,
  },
  actions: {
    clearStateTrackStop({ commit }) {
      commit('clearStateTrackStop');
    },
  },
  mutations: {
    setViewTrackOnMap(state, payload) {
      state.viewTrackOnMap = payload;
    },
    setStateTrackStopOnMap(state, payload) {
      state.stateTrackStopOnMap = payload;
    },
    clearStateTrackStop(state) {
      state.viewTrackOnMap = null;
      state.stateTrackStopOnMap = {
        active: false,
      };
    }
  }
}